export type TAccountFormsState = {
    loginComponent: boolean;
    registerComponent: boolean;
};

export const $AccountFormsModuleName = "accountForms";
